import * as React from 'react'
export const LogoOpera = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={96} height={100} {...props}>
    <path
      fill="#EB6060"
      fillRule="evenodd"
      d="M48 100C21.49 100 0 77.614 0 50S21.49 0 48 0s48 22.386 48 50-21.49 50-48 50zm0-10c13.807 0 25-17.909 25-40S61.807 10 48 10 23 27.909 23 50s11.193 40 25 40z"
    />
  </svg>
)
